export default __webpack_public_path__ + "4f7026ae4b5951bd6d536d5139a45506.svg";